'use client';
import { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import Button from '../Button';
import VideoPlayerMenu from './VideoPlayerMenu';
import { getVideo } from '../../../../utils/videoDB';
import AirtableButton from '../AirtableButton';
import AirtableVideoPlayer from './AirtableVideoPlayer';
import SplashText from '../SplashText';
import axios from 'axios';
import { usePxToVw } from '../../../../hooks/usePxToVw';

const AirtableMenu = ({
  userId,
  airtableConfig,
  airtableData,
  airtableVideosDownloaded = false,
  brandColor,
  globalSettings,
  airTablesettings,
  buttonSettings,
  onBackToMenu,
  numColumns = 'center-two-buttons-per-row',
  columnSpacing = 5,
  enableOffset = false,
  leftOffset = 5,
  topOffset = 5,
  rightOffset = 0,
  lineHeight = 0.6,
  padding = 20,
  fontSize = 20,
  brandFont = 'Arial',
  uploadedUrls = {},
  splashText = '',
  videotime = 0,
  isSecondView = false,
  isthirdView = false,
  resetSession,
  changeVideoFun,
  removeWhiteFlashOnVideo,
  client_url,
  disableAnimation = false,
}) => {
  const { pxToVw, getMaxWidth } = usePxToVw();
  const videoRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [clicked, setClicked] = useState(false);
  const [playCount, setPlayCount] = useState(0);
  const [videoComplete, setVideoComplete] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isPlayingVideo, setIsPlayingVideo] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (airtableData.length > 0) {
      const buttonsPerPage = airtableConfig?.buttonsPerPage || 6;
      setTotalPages(Math.ceil(airtableData.length / buttonsPerPage));
    }
  }, [airtableData, airtableConfig]);

  useEffect(() => {
    if (editOpen && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (countdown === 0) {
      handleCountdownComplete();
    }
  }, [editOpen, countdown]);

  const handleCountdownComplete = () => {
    console.log('Countdown finished! Perform action here.');

    if (videoRef?.current) {
      videoRef.current.pause();
      videoRef.current.removeAttribute('src');
      videoRef.current.load();
    }

    resetSession();
  };

  const modalClodeFun = () => {
    setPlayCount(0);
    setVideoComplete(false);
    setEditOpen(false);
    setCountdown(5);

    changeVideoFun();
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      videoRef.current.load();
      videoRef.current.onloadeddata = () => {
        videoRef.current.play();
      };
    }
  };

  const handleTextClick = async itemId => {
    const selectedItem = airtableData.find(item => item.id === itemId);

    console.log('selectedItem', selectedItem);

    if (selectedItem) {
      try {
        const decodedUrl = decodeURIComponent(selectedItem.videoUrl);
        const fileName = decodedUrl.split('/').pop();

        console.log('Attempting to get video from IndexedDB:', fileName);

        const videoBlob = await getVideo(selectedItem.id);
        console.log('videoBlob', videoBlob);
        const blob = videoBlob?.blob;
        if (blob && blob instanceof Blob) {
          console.log('Video found in IndexedDB, creating blob URL');
          const videoUrl = URL.createObjectURL(blob);
          setSelectedVideo({
            ...selectedItem,
            localVideoUrl: videoUrl,
          });
          setClicked(true);
        } else {
          console.log('Video not found in IndexedDB, using original URL');
          setSelectedVideo({
            ...selectedItem,
            localVideoUrl: selectedItem.videoUrl,
          });
          setClicked(true);
        }
      } catch (error) {
        console.error('Error retrieving video from IndexedDB:', error);
        setSelectedVideo({
          ...selectedItem,
          localVideoUrl: selectedItem.videoUrl,
        });
        setIsPlayingVideo(true);
        setClicked(true);
      }

      try {
        await axios.post('/api/airtablebtnclick', {
          selectedItem,
          client_url,
        });
      } catch (error) {
        console.error('Failed to save media data:', error);
      }
    }
  };

  const handleAnimationComplete = index => {
    if (index === 0) {
      setPlayCount(0);
      setVideoComplete(false);
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
      setIsPlayingVideo(true);
    }
  };

  const handleVideoPlayPage = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.muted = false;
    }
  };

  const handleVideoEnd = () => {
    if (isPlayingVideo && selectedVideo) {
      setIsTransitioning(true);
      setIsPlayingVideo(false);
      setSelectedVideo(null);
      setClicked(false);
      setIsTransitioning(false);
      setTimeout(() => {
        // setIsPlayingVideo(false)
        // setSelectedVideo(null)
        // setClicked(false)
        // setIsTransitioning(false)
      }, 50);
      return;
    }

    if (videotime === 0) {
      videoRef.current.play();
    } else if (playCount < videotime - 1) {
      setPlayCount(prevCount => prevCount + 1);
      videoRef.current.play();
    } else {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = videoRef.current.duration - 0.5;
      }
      setEditOpen(true);
    }
  };

  const backToMenufun = () => {
    setPlayCount(0);
    setVideoComplete(false);
    setIsTransitioning(true);
    setTimeout(() => {
      // setIsPlayingVideo(false)
      // setSelectedVideo(null)
      // setIsTransitioning(false)
      // if (videoRef?.current) {
      //   videoRef.current.pause()
      //   videoRef.current.removeAttribute("src")
      //   videoRef.current.load()
      // }
      // onBackToMenu()
    }, 50);

    setIsPlayingVideo(false);
    setSelectedVideo(null);
    setIsTransitioning(false);
    if (videoRef?.current) {
      videoRef.current.pause();
      videoRef.current.removeAttribute('src');
      videoRef.current.load();
    }
    onBackToMenu();
  };
  useEffect(() => {
    if (clicked && disableAnimation) {
      handleAnimationComplete(0);
    }
  }, [clicked]);

  const buttonsPerPage = airtableConfig?.buttonsPerPage || 6;
  const startIndex = (currentPage - 1) * buttonsPerPage;
  const endIndex = startIndex + buttonsPerPage;
  const currentPageData = airtableData.slice(startIndex, endIndex);

  const renderButtons = () => {
    const menu = currentPageData;

    if (numColumns === 'center-single-row') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(columnSpacing)}`,
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                  onClick: () => handleTextClick(item?.id),
                }
              : {
                  custom: { index, type: clicked ? 'slideOut' : 'visible' },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  variants: {
                    hidden: custom => ({
                      x: item.side === 'left' ? '-100vw' : '100vw',
                      opacity: 1,
                      transition: {
                        type: 'spring',
                        damping: 15,
                        stiffness: 100,
                        delay: index * 0.2,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      transition: {
                        type: 'spring',
                        damping: 15,
                        stiffness: 100,
                        delay: index * 0.2,
                      },
                    }),
                    slideOut: custom => ({
                      x: item.side === 'left' ? '-100vw' : '100vw',
                      opacity: 1,
                      transition: {
                        type: 'spring',
                        damping: 15,
                        stiffness: 100,
                        delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                      },
                    }),
                  },

                  onClick: () => handleTextClick(item?.id),

                  onAnimationComplete: definition => {
                    if (definition === 'slideOut') {
                      handleAnimationComplete(index);
                    }
                  },
                };
            return (
              <ButtonWrapper key={index} {...animationProps} className="text-item">
                <Button
                  key={index}
                  text={item?.name}
                  settings={airTablesettings?.globalSettings}
                  keyid={item?.id}
                />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'center-two-buttons-per-row') {
      const leftButtons = (menu || []).filter(item => item.side === 'left');
      const rightButtons = (menu || []).filter(item => item.side === 'right');

      return (
        <div style={{ display: 'flex', justifyContent: 'center', gap: `${pxToVw(columnSpacing)}` }}>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: `${pxToVw(columnSpacing)}` }}
          >
            {leftButtons.map((item, index) => {
              const ButtonWrapper = disableAnimation ? 'div' : motion.div;
              const animationProps = disableAnimation
                ? {
                    onClick: () => handleTextClick(item?.id),
                  }
                : {
                    custom: { index, direction: 'left' },
                    initial: 'hidden',
                    animate: clicked ? 'slideOut' : 'visible',
                    variants: {
                      hidden: custom => ({
                        x: '-100vw',
                        opacity: 1,
                        scale: 0.95,
                        transition: {
                          type: 'easeInOut',
                          damping: 30,
                          duration: 1,
                          stiffness: 20,
                          delay: custom.index * 0.15,
                        },
                      }),
                      visible: custom => ({
                        x: 0,
                        opacity: 1,
                        scale: 1,
                        transition: {
                          ease: 'easeInOut',
                          damping: 30,
                          duration: 1,
                          stiffness: 20,
                          delay: custom.index * 0.15,
                        },
                      }),
                      slideOut: custom => ({
                        x: '-100vw',
                        opacity: 0,
                        scale: 0.95,
                        transition: {
                          ease: 'easeInOut',
                          duration: 1,
                          delay: 1 + (leftButtons.length - 1 - custom.index) * 0.15,
                        },
                      }),
                    },

                    onClick: () => handleTextClick(item?.id),
                  };

              return (
                <ButtonWrapper key={index} {...animationProps} className="text-item">
                  <Button
                    key={index}
                    text={item?.name}
                    settings={airTablesettings?.globalSettings}
                    keyid={item?.id}
                  />
                </ButtonWrapper>
              );
            })}
          </div>

          <div
            style={{ display: 'flex', flexDirection: 'column', gap: `${pxToVw(columnSpacing)}` }}
          >
            {rightButtons.map((item, index) => {
              const ButtonWrapper = disableAnimation ? 'div' : motion.div;
              const animationProps = disableAnimation
                ? {
                    onClick: () => handleTextClick(item?.id),
                  }
                : {
                    custom: { index, direction: 'right' },
                    initial: 'hidden',
                    animate: clicked ? 'slideOut' : 'visible',
                    variants: {
                      hidden: custom => ({
                        x: '100vw',
                        opacity: 1,
                        scale: 0.95,
                        transition: {
                          type: 'easeInOut',
                          damping: 30,
                          duration: 1,
                          stiffness: 20,
                          delay: custom.index * 0.15,
                        },
                      }),
                      visible: custom => ({
                        x: 0,
                        opacity: 1,
                        scale: 1,
                        transition: {
                          ease: 'easeInOut',
                          damping: 30,
                          duration: 1,
                          stiffness: 20,
                          delay: custom.index * 0.15,
                        },
                      }),
                      slideOut: custom => ({
                        x: '100vw',
                        opacity: 0,
                        scale: 0.95,
                        transition: {
                          ease: 'easeInOut',
                          duration: 1,
                          delay: 1 + (rightButtons.length - 1 - custom.index) * 0.15,
                        },
                      }),
                    },

                    onClick: () => handleTextClick(item?.id),
                    onAnimationComplete: definition => {
                      if (definition === 'slideOut') {
                        handleAnimationComplete(index);
                      }
                    },
                  };
              return (
                <ButtonWrapper key={index} {...animationProps} className="text-item">
                  <Button
                    key={index}
                    text={item?.name}
                    settings={airTablesettings?.globalSettings}
                    keyid={item?.id}
                  />
                </ButtonWrapper>
              );
            })}
          </div>
        </div>
      );
    } else if (numColumns === 'right-side-one-button-per-row') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: `${pxToVw(columnSpacing)}`,
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                  onClick: () => handleTextClick(item?.id),
                }
              : {
                  custom: { index, direction: 'right' },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  variants: {
                    hidden: custom => ({
                      x: '100vw',
                      opacity: 1,
                      scale: 0.95,
                      transition: {
                        type: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      scale: 1,
                      transition: {
                        ease: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.1,
                      },
                    }),
                    slideOut: custom => ({
                      x: '100vw',
                      opacity: 0,
                      scale: 0.95,
                      transition: {
                        ease: 'easeInOut',
                        duration: 1,
                        delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.15,
                      },
                    }),
                  },

                  onClick: () => handleTextClick(item?.id),
                  onAnimationComplete: definition => {
                    if (definition === 'slideOut') {
                      handleAnimationComplete(index);
                    }
                  },
                };
            return (
              <ButtonWrapper key={index} {...animationProps} className="text-item">
                <Button
                  key={index}
                  text={item?.name}
                  settings={airTablesettings?.globalSettings}
                  keyid={item?.id}
                />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'left-side-one-button-per-row') {
      const sortedMenuu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: `${pxToVw(columnSpacing)}`,
          }}
        >
          {sortedMenuu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                  onClick: () => handleTextClick(item?.id),
                }
              : {
                  custom: { index },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  exit: 'slideOut',
                  variants: {
                    hidden: custom => ({
                      x: '-100vw',
                      opacity: 1,
                      scale: 0.95,
                      transition: {
                        type: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      scale: 1,
                      transition: {
                        ease: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.1,
                      },
                    }),
                    slideOut: custom => ({
                      x: '-100vw',
                      opacity: 0,
                      scale: 0.95,
                      transition: {
                        ease: 'easeInOut',
                        duration: 1,
                        delay: 1 + (sortedMenuu.length - 1 - custom.index) * 0.15,
                      },
                    }),
                  },

                  onClick: () => handleTextClick(item?.id),
                  onAnimationComplete: definition => {
                    if (definition === 'slideOut') {
                      handleAnimationComplete(index);
                    }
                  },
                };
            return (
              <ButtonWrapper key={index} {...animationProps} className="text-item">
                <Button
                  key={index}
                  text={item?.name}
                  settings={airTablesettings?.globalSettings}
                  keyid={item?.id}
                />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    }
  };

  if (airtableData.length === 0) {
    return (
      <div
        className="airtable-menu-container"
        style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
      >
        <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
          <div className="alert alert-danger">
            <h5>No Airtable Data</h5>
            <p>No valid records found in your Airtable configuration.</p>
            <small>Please check your Airtable setup and field mappings.</small>
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: brandColor,
              color: '#fff',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              marginTop: '20px',
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  const videoRunTime = () => {
    return (
      <AnimatePresence mode="wait">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: isTransitioning ? 0 : 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15, ease: 'easeInOut' }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#000',
            zIndex: 10,
          }}
        >
          <AirtableVideoPlayer
            videoRef={videoRef}
            videoKey={selectedVideo}
            handleVideoPlayPage={handleVideoPlayPage}
            handleVideoEnd={handleVideoEnd}
            removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
          />

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1 }}
          >
            <img
              src={
                buttonSettings?.backButtonSettings?.backButtonMedia?.fileUrl || '/placeholder.svg'
              }
              alt="Logo"
              style={{
                position: 'fixed',
                padding: '15px',
                top: '46%',
                left: '12px',
                cursor: 'pointer',
                zIndex: 15,
                display: buttonSettings?.backButtonSettings?.backButtonMedia?.enabled
                  ? 'block'
                  : 'none',
              }}
              onClick={() => handleVideoEnd()}
            />
          </motion.div>
        </motion.div>
      </AnimatePresence>
    );
  };

  if (isPlayingVideo && selectedVideo) {
    return (
      <motion.div
        className=""
        style={{
          cursor: 'pointer',
          backgroundColor: '#000',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9,
        }}
        onClick={() => handleVideoEnd()}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.15, ease: 'easeInOut' }}
      >
        {videoRunTime()}
      </motion.div>
    );
  } else {
    return (
      <motion.div
        className=""
        initial={{ opacity: 0 }}
        animate={{ opacity: isTransitioning ? 0 : 1 }}
        transition={{ duration: 0.15, ease: 'easeInOut' }}
        style={{
          backgroundColor: '#000',
          minHeight: '100vh',
          position: 'relative',
          width: '100%',
        }}
      >
        {isTransitioning && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: '#000',
              zIndex: 20,
            }}
          />
        )}

        {(!isSecondView && !isthirdView) ||
        (isSecondView && !uploadedUrls?.splashVideotwo?.enabled) ||
        (isthirdView && !uploadedUrls?.splashVideothree?.enabled) ? (
          <AnimatePresence mode="wait">
            <VideoPlayerMenu
              videoRef={videoRef}
              videoKey={uploadedUrls?.splashVideo?.fileUrl}
              handleVideoPlayPage={handleVideoPlayPage}
              handleVideoEnd={handleVideoEnd}
              removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            />
          </AnimatePresence>
        ) : (
          ''
        )}

        {isSecondView && uploadedUrls?.splashVideotwo?.enabled ? (
          <AnimatePresence mode="wait">
            <VideoPlayerMenu
              videoRef={videoRef}
              videoKey={uploadedUrls?.splashVideotwo?.fileUrl}
              handleVideoPlayPage={handleVideoPlayPage}
              handleVideoEnd={handleVideoEnd}
              removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            />
          </AnimatePresence>
        ) : (
          ''
        )}

        {isthirdView && uploadedUrls?.splashVideothree?.enabled ? (
          <AnimatePresence mode="wait">
            <VideoPlayerMenu
              videoRef={videoRef}
              videoKey={uploadedUrls?.splashVideothree?.fileUrl}
              handleVideoPlayPage={handleVideoPlayPage}
              handleVideoEnd={handleVideoEnd}
              removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            />
          </AnimatePresence>
        ) : (
          ''
        )}

        <div className="corner-overlays-responsive">
          <AnimatePresence mode="wait">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: isTransitioning ? 0 : 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeInOut' }}
              className="corner-item top-left"
              style={{ justifyContent: 'left' }}
            >
              <img
                src={uploadedUrls?.leftTop?.fileUrl || '/placeholder.svg'}
                alt="Logo"
                style={{
                  display: uploadedUrls?.leftTop?.enabled ? 'block' : 'none',
                  ...(uploadedUrls?.leftTop?.width > 0
                    ? { width: `${uploadedUrls?.leftTop?.width}vw` }
                    : {}),
                  ...(uploadedUrls?.leftTop?.height > 0
                    ? { height: `${uploadedUrls?.leftTop?.height}vw` }
                    : {}),
                  maxWidth: `${uploadedUrls.leftTop.width > 0 ? '100vw' : getMaxWidth('25vw')}`,
                }}
              />
            </motion.div>
          </AnimatePresence>

          <AnimatePresence mode="wait">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: isTransitioning ? 0 : 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeInOut' }}
              className="corner-item back-button"
            >
              <img
                src={uploadedUrls?.backMenuMedia?.fileUrl || '/placeholder.svg'}
                alt="Logo"
                style={{
                  display: uploadedUrls?.backMenuMedia?.enabled ? 'block' : 'none',
                  maxWidth: getMaxWidth('50vw'),
                  // maxHeight: getMaxWidth('30vw'),
                  width: uploadedUrls?.backMenuMedia?.width > 0 ? `${uploadedUrls.backMenuMedia.width}%` : '100%',
                 height: '30vw',
                }}
                onClick={() => backToMenufun()}
              />
            </motion.div>
          </AnimatePresence>

          <AnimatePresence mode="wait">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: isTransitioning ? 0 : 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeInOut' }}
              style={{ justifyContent: 'right' }}
              className="corner-item top-right"
            >
              <img
                src={uploadedUrls?.rightTop?.fileUrl || '/placeholder.svg'}
                alt="Logo"
                style={{
                  display: uploadedUrls?.rightTop?.enabled ? 'block' : 'none',
                  ...(uploadedUrls?.rightTop?.width > 0
                    ? { width: `${uploadedUrls?.rightTop?.width}vw` }
                    : {}),
                  ...(uploadedUrls?.rightTop?.height > 0
                    ? { height: `${uploadedUrls?.rightTop?.height}vw` }
                    : {}),
                  maxWidth: `${uploadedUrls.rightTop.width > 0 ? '100vw' : getMaxWidth('25vw')}`,
                }}
              />
            </motion.div>
          </AnimatePresence>

          <AnimatePresence mode="wait">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: isTransitioning ? 0 : 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeInOut' }}
              style={{ justifyContent: 'right' }}
              className="corner-item bottom-right"
            >
              <img
                src={uploadedUrls?.rightBottom?.fileUrl || '/placeholder.svg'}
                alt="Logo"
                style={{
                  // position: "fixed",
                  // padding: "15px",
                  // bottom: "0",
                  // zIndex: 2,
                  // right: "5px",
                  display: uploadedUrls?.rightBottom?.enabled ? 'block' : 'none',
                  ...(uploadedUrls?.rightBottom?.width > 0
                    ? { width: `${uploadedUrls?.rightBottom?.width}vw` }
                    : {}),
                  ...(uploadedUrls?.rightBottom?.height > 0
                    ? { height: `${uploadedUrls?.rightBottom?.height}vw` }
                    : {}),
                  maxWidth: `${uploadedUrls.rightBottom.width > 0 ? '100%' : getMaxWidth('25vw')}`,
                }}
              />
            </motion.div>
          </AnimatePresence>

          <AnimatePresence mode="wait">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: isTransitioning ? 0 : 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeInOut' }}
              className="corner-item bottom-left"
              style={{ justifyContent: 'left' }}
            >
              <img
                src={uploadedUrls?.leftBottom?.fileUrl || '/placeholder.svg'}
                alt="Logo"
                style={{
                  display: uploadedUrls?.leftBottom?.enabled ? 'block' : 'none',
                  ...(uploadedUrls?.leftBottom?.width > 0
                    ? { width: `${uploadedUrls?.leftBottom?.width}vw` }
                    : {}),
                  ...(uploadedUrls?.leftBottom?.height > 0
                    ? { height: `${uploadedUrls?.leftBottom?.height}vw` }
                    : {}),
                  maxWidth: `${uploadedUrls.leftBottom.width > 0 ? '100%' : getMaxWidth('25vw')}`,
                }}
              />
            </motion.div>
          </AnimatePresence>
        </div>

        <div
          style={{
            position: 'fixed',
            top: enableOffset ? `${topOffset}%` : 0,
            left: enableOffset ? `${leftOffset}%` : 0,
            ...(enableOffset && rightOffset > 0 ? { right: `${rightOffset}%` } : {}),
            ...(enableOffset ? {} : { width: '100%' }),
            ...(enableOffset ? {} : { height: '100%' }),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
          }}
        >
          <SplashText
            text={splashText || 'Splash Text'}
            settings={globalSettings}
            style={{
              marginBottom: '20px',
            }}
          />

          <AnimatePresence mode="wait">
            <motion.div
              style={{
                display: 'flex',
                flexDirection: numColumns === 'center-single-row' ? 'row' : 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
              initial={{ opacity: 0 }}
              animate={{ opacity: isTransitioning ? 0 : 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeInOut' }}
            >
              {renderButtons()}
            </motion.div>
          </AnimatePresence>

          {totalPages > 1 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: `${pxToVw(columnSpacing)}`,
                marginTop: '30px',
              }}
            >
              <AirtableButton
                text={airtableConfig?.backButtonText || 'BACK'}
                settings={{
                  ...buttonSettings?.backButtonSettings,
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  opacity: currentPage === 1 ? 0.2 : 1,
                }}
                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
              />

              <AirtableButton
                text={airtableConfig?.nextButtonText || 'NEXT'}
                settings={{
                  ...buttonSettings?.nextButtonSettings,
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  opacity: currentPage === totalPages ? 0.2 : 1,
                }}
                onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                disabled={currentPage === totalPages}
              />
            </div>
          )}

          <AnimatePresence mode="wait">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: isTransitioning ? 0 : 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeInOut' }}
            >
              <img
                src={uploadedUrls?.centerBelowMenuMedia?.fileUrl || '/placeholder.svg'}
                alt="Logo"
                style={{
                  marginTop: '30px',
                  display: uploadedUrls?.centerBelowMenuMedia?.enabled ? 'block' : 'none',
                  width: 'auto',
                  height: 'auto',
                }}
              />
            </motion.div>
          </AnimatePresence>
        </div>

        <Dialog
          open={editOpen}
          onClose={modalClodeFun}
          sx={{
            '& .MuiDialog-paper': {
              backgroundColor: '#FFFFFF', // White modal background
              border: `2px solid ${brandColor}`,
              // padding: `${padding}px`,
              padding: '2vw',
              borderRadius: '20px',
              width: '35vw',
              maxWidth: '70vw',
              // height:'auto'

              // marginLeft:`${triviaQuizSettings?.quizsetting?.leftoffset}%`
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent', // Change this to any color (Example: Red with opacity)
            },
            // "& .MuiDialog-container": {
            //  marginLeft:`${triviaQuizSettings?.quizsetting?.leftoffset}%`,
            //  justifyContent: "unset", // Remove justify-content
            // WebkitJustifyContent: "unset", // Remove -webkit-justify-content
            // },
          }}
        >
          <DialogTitle
            style={{
              textAlign: 'center',
              fontSize: `3vw`,
              fontFamily: brandFont,
              // lineHeight: lineHeight
            }}
          >
            Are You There?
          </DialogTitle>

          <DialogTitle
            style={{
              textAlign: 'center',
              fontSize: `3vw`,
              fontFamily: brandFont,
              // lineHeight: lineHeight
            }}
          >
            {countdown}
          </DialogTitle>
          <DialogActions>
            <button
              style={{
                margin: '0 auto',
                background: brandColor,
                fontFamily: brandFont,
                fontSize: `2vw`,
                height: 'auto',
                maxHeight: '10vw',
                padding: '0.5vw 1vw',
              }}
              onClick={modalClodeFun}
            >
              Yes
            </button>
          </DialogActions>
        </Dialog>
      </motion.div>
    );
  }
};

export default AirtableMenu;
